import { Route } from "vue-router";
import { AuthenticatedService } from "../abstract/base.service";
import { ListRequest } from "@/models/grids/list.request";
import OrderBy from "@/models/shared/orderby";
import { ListResponse } from "@/models/grids/list.response";
import { GetAppGroupDtoQuery } from "@/server/app.queries";
import { AppGroupDto } from "@/server/app.dtos";
import { CreateAppGroupCommand, EditAppGroupCommand } from "@/server/app.commands";

export const AppGroupEndpoint = `api/appgroups`;


export class AppGroupService extends AuthenticatedService {
  GetList(request: GetAppGroupDtoQuery): Promise<AppGroupDto[]> {
    return this.Get<AppGroupDto[]>(
      `${this.baseUrl}${AppGroupEndpoint}?${this.GetQueryStringByObject(request)}`
    );
  }

  GetSingle(request: GetAppGroupDtoQuery): Promise<AppGroupDto> {
    return this.Get<AppGroupDto>(
      `${this.baseUrl}${AppGroupEndpoint}/${
        request.idAppGroup
      }?${this.GetQueryStringByObject(request)}`
    );
  }

  Create(entity: CreateAppGroupCommand): Promise<number> {
    return this.Post<number>(`${this.baseUrl}${AppGroupEndpoint}`, entity);
  }

  Edit(command: EditAppGroupCommand): Promise<number> {
    return this.Put<number>(
      `${this.baseUrl}${AppGroupEndpoint}/${command.idAppGroup}`,
      command
    );
  }

  DeleteById(id: number): Promise<number> {
    return this.Delete(`${this.baseUrl}${AppGroupEndpoint}/${id}`);
  }
}
